import { render, staticRenderFns } from "./TraderSettings.vue?vue&type=template&id=17e46d43&"
import script from "./TraderSettings.vue?vue&type=script&lang=js&"
export * from "./TraderSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports